import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index";

Vue.use(VueRouter);

const routes = [{
  path: "/",
  name: "Home",
  component: Layout,
  redirect: "/index",
  children: [
    {
      path: "/index",
      name: "index",
      component: () => import("@/views/index")
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/home")
    },
    {
      path: "/about",
      name: "about",
      component: () => import("@/views/about")
    },
  ]
}];

const router = new VueRouter({
  routes
});

export default router;
